import { createContext } from 'react';
import { DialogContextState } from './types';

export const DialogContext = createContext<DialogContextState>(null);
